export default __webpack_public_path__ + "static/media/y.ca6a1575.svg";